import {createActionWithoutPayload, createActionWithPayload} from "./utils.actions";
import {Periodical} from "../../types/periodical";

// Fetch periodicals
export const [fetchPeriodicals, isFetchPeriodicalsAction] = createActionWithoutPayload('REST_FETCH_PERIODICALS');
export const [fetchPeriodicalsSuccess, isFetchPeriodicalsSuccessAction] = createActionWithPayload<Periodical[]>('FETCH_PERIODICALS_SUCCESS');
export const [fetchPeriodicalsError, isFetchPeriodicalsErrorAction] = createActionWithoutPayload('FETCH_PERIODICALS_ERROR');

export const [updatePeriodicalSelection, isUpdatePeriodicalSelectionAction] = createActionWithPayload<string[]>('UPDATE_PERIODICAL_SELECTION');
